var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "24", height: "17", viewBox: "0 0 24 17", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M12 .25a2.75 2.75 0 0 1 .75 5.397V7c0 .06-.007.117-.02.173.695.106 1.37.369 1.974.787l8.09 5.601a1.75 1.75 0 0 1-.995 3.189H2.2a1.75 1.75 0 0 1-.996-3.189L9.296 7.96a4.742 4.742 0 0 1 1.975-.789.49.49 0 0 1-.014-.07L11.25 7V5a.75.75 0 0 1 .75-.75 1.25 1.25 0 1 0-1.244-1.378L10.75 3a.75.75 0 1 1-1.5 0A2.75 2.75 0 0 1 12 .25zm1.85 8.943a3.25 3.25 0 0 0-3.7 0l-8.09 5.601a.25.25 0 0 0 .142.456H21.8a.25.25 0 0 0 .142-.456z", fill: "#292D32" })
  );
});